import {
  ColumnDefinitionArdoqMetadata,
  InventoryReferenceRepresentation,
} from '../types';
import { ComponentCellRendererProps } from './types';
import { cellRendererPropsOperations } from './cellRendererPropsOperations';
import { NotApplicable, NoValue } from './atoms';
import { ComponentTags } from './ComponentTags';

export const ReferenceRenderer = (
  props: ComponentCellRendererProps<InventoryReferenceRepresentation[]>
) => {
  if (!cellRendererPropsOperations.isComponentColumnApplicable(props))
    return <NotApplicable />;
  if (cellRendererPropsOperations.isEditingCell(props)) return null; // This is here because the render will appear behind the editor when the cell is being edited

  const columnContext = props.colDef?.context as ColumnDefinitionArdoqMetadata;
  if (columnContext.inventoryColumnType !== 'reference') return null;

  const isOutgoing = columnContext.direction === 'outgoing';
  const componentIds =
    props.value?.map(it => (isOutgoing ? it.target : it.source)) ?? [];

  return componentIds.length ? (
    <ComponentTags
      componentIds={componentIds}
      scopeData={cellRendererPropsOperations.getScopeData(props)}
      getOpenComponentOverview={cellRendererPropsOperations.getOpenComponentOverview(
        props.context
      )}
      i18nLocale={props.context.i18nLocale}
    />
  ) : (
    <NoValue />
  );
};
